import {
    CLUB_API_BASE_URL,
    ClubRegisterResponse,
    DOI_ERROR_CODE,
    HTTP_STATUS_OK,
    LOGIN_API,
    ResponseError,
    SIGNUP_API,
    STATUS,
} from 'SharedHelpers/LoginRegisterFormAPI';
import { apiPost, CallFetchOptions, FetchResponse } from 'SharedHelpers/apiFetch';
import { OnFailureData, OnSuccess, ValidationErrors } from 'Interfaces/Api';
import { LoginFormValues, SignupFormValues } from 'Interfaces/LoginRegisterFormProps';

export default class SalesApi {
    private readonly apiPostSignupLogin = async <E = {}>(
        url: string,
        body: string,
        options: Exclude<CallFetchOptions, 'body'> = {}
    ): Promise<FetchResponse<ClubRegisterResponse>> =>
        apiPost<ClubRegisterResponse, E>(url, body, {
            headers: this._getHeaders(),
            ...options,
        });

    private _getHeaders = (headers: object = {}): Headers =>
        new Headers({ 'Content-Type': 'application/json; charset=utf-8', ...headers });

    private _getSignupUrl = () => `${CLUB_API_BASE_URL}${SIGNUP_API.URL}`;

    private _getLoginUrl = () => `${CLUB_API_BASE_URL}${LOGIN_API.URL}`;

    // TODO Move to helpers
    public getValidationErrors = (error: ResponseError): ValidationErrors =>
        (error?.validation_errors || {}) as ValidationErrors;

    // TODO Move to helpers
    public isDoiRequired = (error?: ResponseError): boolean => !!error && error.code === DOI_ERROR_CODE;

    private _isErrorResponse = (apiResponse: FetchResponse<ClubRegisterResponse>) => {
        const {
            response: { status },
            data: { status: dataStatus },
        } = apiResponse;
        return status !== HTTP_STATUS_OK || dataStatus === STATUS.ERROR;
    };

    private _getUrlParams = (formValues: SignupFormValues | LoginFormValues): string => JSON.stringify(formValues);

    private _register = async (formValues: SignupFormValues): Promise<FetchResponse<ClubRegisterResponse>> =>
        this.apiPostSignupLogin(this._getSignupUrl(), this._getUrlParams(formValues));

    private _login = async (formValues: LoginFormValues): Promise<FetchResponse<ClubRegisterResponse>> =>
        this.apiPostSignupLogin(this._getLoginUrl(), this._getUrlParams(formValues));

    public registerUser = async (
        formValues: SignupFormValues,
        onSuccess: OnSuccess,
        onFailureData: OnFailureData<ClubRegisterResponse | {}>
    ): Promise<void> => {
        try {
            const apiResponse = await this._register(formValues);
            if (!this._isErrorResponse(apiResponse)) {
                onSuccess();
                return;
            }
            onFailureData(apiResponse.data);
        } catch (e) {
            onFailureData({});
        }
    };

    public loginUser = async (
        formValues: LoginFormValues,
        onSuccess: OnSuccess,
        onFailureData: OnFailureData<ClubRegisterResponse | {}>
    ): Promise<void> => {
        try {
            const apiResponse = await this._login(formValues);
            if (!this._isErrorResponse(apiResponse)) {
                onSuccess();
                return;
            }
            onFailureData(apiResponse.data);
        } catch (e) {
            onFailureData({});
        }
    };
}
